window.slate = window.slate || {};
window.theme = window.theme || {};

// Track popup display
slate.popUpShown = false;
slate.redirectPopupShown = false;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === 'undefined'
        ? ''
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === 'undefined'
        ? ''
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    var match_asset = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else if (match_asset) {
      var prefix = src.split(match_asset[0]);
      var suffix = match_asset[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/
theme.Slideshow = (function () {
  /**
   * Slideshow section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    $(document).ready(function () {
      var $mainSlideshow = $('.main-slideshow');

      // Only run if slideshow found
      if ($mainSlideshow.length) {
        $mainSlideshow.owlCarousel({
          navigation: true, // Show next and prev buttons

          slideSpeed: 300,
          paginationSpeed: 400,

          items: 1,
          itemsDesktop: false,
          itemsDesktopSmall: false,
          itemsTablet: false,
          itemsMobile: false,
        });
      }
    });
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    onSelect: function (event) {
      // Reinitialize slideshow height (the adaptiveHeight variable doesn't work properly in the admin)
      var $mainSlideshow = $('.main-slideshow');
      $mainSlideshow.slick('resize');
    },
    onBlockSelect: function (event) {
      var $mainSlideshow = $('.main-slideshow'),
        $slide = $(event.target),
        slideIndex = $slide.data('index');

      // Go to selected slide, pause autoplay
      $mainSlideshow.slick('slickGoTo', slideIndex);
      $mainSlideshow.slick('slickPause');
    },
    onBlockDeselect: function () {
      var $mainSlideshow = $('.main-slideshow');

      // Resume autoplay
      if ($mainSlideshow.hasClass('autoplay-slideshow')) {
        $mainSlideshow.slick('slickPlay');
      }
    },
  });

  return Slideshow;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    iWish: '.iwishAddWrap',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    payLater: '.pay-later',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productPriceAfterpay: '[data-product-price-afterpay]',
    productPriceLaybuy: '[data-product-price-laybuy]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      'variantChange' + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      'variantPriceChange' + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr('src')
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        $(selectors.payLater, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass('hide');
        $(selectors.payLater, this.$container).removeClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container)
          .prop('disabled', false)
          .removeClass('disabled');
        $(selectors.iWish, this.$container).removeClass('disabled');
        if (
          $(selectors.addToCart, this.$container).data('preorder') !== undefined
        ) {
          $(selectors.addToCartText, this.$container).html(
            theme.strings.preorder
          );
        } else {
          $(selectors.addToCartText, this.$container).html(
            theme.strings.addToCart
          );
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $payLater = $(selectors.payLater, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $afterpayPrice = $(selectors.productPriceAfterpay, this.$container);
      var $laybuyPrice = $(selectors.productPriceLaybuy, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );
      $afterpayPrice.html(
        slate.Currency.formatMoney(variant.price / 4, theme.moneyFormat)
      );
      $laybuyPrice.html(
        slate.Currency.formatMoney(variant.price / 6, theme.moneyFormat)
      );
      $payLater.removeClass('hide');

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

theme.NewsletterPopup = (function () {
  var $html = $('html'),
    $newsletterPopup = $('.newsletter-popup'),
    $triggerNewsletterPopup = $('.trigger-newsletter-popup'),
    queryString = window.location.search.substring(1);

  if ($newsletterPopup.length) {
    // Show newsletter popup after 4s if it hasn't been shown yet
    if ($newsletterPopup.hasClass('auto-show')) {
      if (!localStorage.getItem('newsletter_popup_shown')) {
        setTimeout(function () {
          $html.addClass('notification-shown');
          localStorage.setItem('newsletter_popup_shown', true);
        }, 4000);
      }
    }

    // Close newsletter popup
    $newsletterPopup.find('a.close').on('click', function (e) {
      e.preventDefault();
      $html.removeClass('notification-shown');
    });

    // Show newsletter popup on button click
    $triggerNewsletterPopup.on('click', function () {
      $html.addClass('notification-shown');
    });

    // Show success message
    if (queryString.indexOf('customer_posted=true') !== -1) {
      if ($newsletterPopup.find('.note').length) {
        $html.addClass('notification-shown');
      }
    }
  }
})();

// AU Klaviyo popup
const klaviyoButtonTrigger = document.querySelector('.klaviyo_form_trigger');
if (klaviyoButtonTrigger) {
  klaviyoButtonTrigger.addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'YzwFnz']);
  });
}

theme.CookiesBar = (function () {
  var $html = $('html'),
    $cookiesBar = $('.cookies-bar');

  if ($cookiesBar.length) {
    // Show cookies bar if it hasn't been closed
    if (!localStorage.getItem('cookies_bar_shown')) {
      $html.addClass('cookies-bar-shown');
    }

    // Hide and don't show again on button click
    $cookiesBar.find('a.btn').on('click', function (e) {
      e.preventDefault();
      $html.removeClass('cookies-bar-shown');
      localStorage.setItem('cookies_bar_shown', true);
    });
  }
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew',
      }
    );
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function (e) {
    e.preventDefault();

    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function (e) {
    var formId = $(this).data('form-id');

    e.preventDefault();

    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function (e) {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');

    e.preventDefault();

    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections(),
    $html = $('html'),
    $body = $('body'),
    $allPopups = $('.popup'),
    $overlay = $('.overlay'),
    $miniCart = $('.mini-cart'),
    $mediaQuery = $('.mq'),
    $header = $('.full-header'),
    $mainMenuItems = $(
      '.main-nav .site-nav > li.site-nav--has-submenu:not(.collections--all)'
    ),
    $submenus = $('.site-nav__submenu'),
    $mobileNav = $('.mobile-nav'),
    $toggleSearch = $('a.search-link'),
    $slideOutSearch = $('.slide-out-search'),
    browserWidth = 'small',
    headerHeight = parseInt($body.css('padding-top'), 10),
    announcementBarTwoLinesHeight = 46,
    windowWidth = $(window).width(),
    resizeTimer,
    scrollTimer;

  sections.register('slideshow', theme.Slideshow);
  sections.register('product', theme.Product);
  sections.register('cookies-bar', theme.CookiesBar);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  $('.currency-switcher a').click(function (e) {
    e.preventDefault();
    localStorage.setItem('preferredCountry', $(this).data('code'));
    window.top.location.href = $(this).attr('href');
  });

  // lazyload
  const lazyLoadInstance = new LazyLoad({
    elements_selector: '.enable_lazy .lazy',
    load_delay: 300, //adjust according to use case
    // ... more custom settings?
  });

  /* Every time the window is scrolled ... */
  $(window).scroll(function () {
    /* autoplay vimeo iframes */
    autoplayVimeo();
  });

  // Format HTML
  var converter = new showdown.Converter();
  converter.makeHtml($('[data-format-text]').html());
  $('[data-format-text]').each(function () {
    $(this).html(converter.makeHtml($(this).html()));
    $(this).fadeIn();
  });

  // custom link hover color
  $('a[data-hover-color]').hover(
    function () {
      $(this).css('color', $(this).data('hover-color'));
    },
    function () {
      $(this).css('color', '#1c1c1c');
    }
  );

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        'supports-no-cookies',
        'supports-cookies'
      );
  }

  // to inches
  const toInches = function (n) {
    let val = n * 0.393701;
    let roundVal = Math.round(val * 2) / 2;
    return Math.round(roundVal * 10) / 10;
  };

  function checkMediaQuery() {
    if ($mediaQuery.width() > 4) {
      browserWidth = 'xxlarge';
    } else if ($mediaQuery.width() > 3) {
      browserWidth = 'xlarge';
    } else if ($mediaQuery.width() > 2) {
      browserWidth = 'large';
    } else if ($mediaQuery.width() > 1) {
      browserWidth = 'medium';
    } else {
      browserWidth = 'small';
    }
  }
  checkMediaQuery();

  if (theme.announcementBarShown) {
    // Set in JS because sometimes notification could go over 2 lines
    function setHeaderHeight() {
      // Only run on mobile
      if (
        browserWidth == 'small' ||
        browserWidth == 'medium' ||
        browserWidth == 'large'
      ) {
        // Only manually set header height if announcement bar runs over 2 lines
        if (
          $('.announcement-bar').outerHeight() > announcementBarTwoLinesHeight
        ) {
          headerHeight = $header.outerHeight();
          $body.css('padding-top', headerHeight);
        } else {
          $body.css('padding-top', '');
        }
      } else {
        $body.css('padding-top', '');
      }
    }
    setHeaderHeight();
  }

  function onResize() {
    checkMediaQuery();

    if (theme.announcementBarShown) {
      setHeaderHeight();
    }
  }

  // Reinitialize fixed header body padding on window resize
  $(window).on('resize', function () {
    // Double check the resize is real (fires fake events on iPhone sometimes)
    if ($(window).width() != windowWidth) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 400);
      windowWidth = $(window).width();
    }
  });

  function stickyNav() {
    if ($(window).scrollTop() > headerHeight) {
      $body.addClass('sticky-nav');
    } else {
      $body.removeClass('sticky-nav');
    }
  }

  $(window).on('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(stickyNav, 50);
  });

  // Show/hide dropdown menus on desktop
  $mainMenuItems.children('a').on('click', function (e) {
    checkMediaQuery();
    // Only run on desktop
    if (browserWidth == 'xlarge' || browserWidth == 'xxlarge') {
      e.preventDefault();
      e.stopPropagation(); // Don't count this as a body click because it will close the menu
      var $submenuParent = $(this).parent();
      $submenuParent.toggleClass('active');
      $mainMenuItems.not($submenuParent).removeClass('active');
    }
  });

  // hide header on scroll down, show on scroll up
  var didScroll;
  var lastScrollTop = 0;
  var delta = 100;
  var navbarHeight = $('.full-header').outerHeight() + 300;

  // on scroll, let the interval function know the user has scrolled
  $(window).scroll(function (event) {
    didScroll = true;
  });
  // run hasScrolled() and reset didScroll status
  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();
    // If current position > last position AND scrolled past navbar...
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('.full-header').removeClass('nav-down').addClass('nav-up');
      $('body').removeClass('header-visible');
    } else {
      // Scroll Up
      // If did not scroll past the document (possible on mac)...
      if (st + $(window).height() < $(document).height()) {
        $('.full-header').removeClass('nav-up').addClass('nav-down');
        $('body').addClass('header-visible');
      }
    }
    lastScrollTop = st;
  }

  // Show/hide main nav panel on mobile
  $('a.toggle-nav').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the nav
    $html.toggleClass('mobile-nav-shown');
    $slideOutSearch.removeClass('shown');
    $toggleSearch.removeClass('active');

    if (theme.enableMiniCart) {
      $html.removeClass('mini-cart-shown');
    }
  });

  $('.mobile-nav li:not(.toggle-nav-mobile) > a').on('click', function () {
    $html.removeClass('mobile-nav-shown');
  });

  // Show/hide dropdown menus on mobile
  $('li.toggle-nav-mobile > a').on('click', function (e) {
    checkMediaQuery();
    // Only run on mobile
    if (
      browserWidth == 'small' ||
      browserWidth == 'medium' ||
      browserWidth == 'large'
    ) {
      e.preventDefault();
      var $submenuParent = $(this).parent();
      $submenuParent.toggleClass('active');
      $('li.toggle-nav-mobile').not($submenuParent).removeClass('active');
    }
  });

  // Toggle mobile search
  $toggleSearch.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Don't count this as a body click because it will close the search
    $html.removeClass('mobile-nav-shown');
    $toggleSearch.toggleClass('active');
    $('#SlideMiniSearch').val('');
    $html.removeClass('mini-cart-shown');
    if ($slideOutSearch.hasClass('shown')) {
      $slideOutSearch.removeClass('shown').find('input').blur();
    } else {
      $slideOutSearch.addClass('shown').find('input').focus();
    }
  });

  // Close popups on button click
  $allPopups.on('click', 'a.close', function (e) {
    e.preventDefault();

    $html.removeClass('popup-shown');
    $allPopups.removeClass('shown');
    $overlay.removeClass('shown');
    slate.popUpShown = false;
  });

  // Close popups on overlay click
  $body.on('click', '.overlay', function () {
    if (slate.popUpShown) {
      if (!slate.redirectPopupShown) {
        $html.removeClass('popup-shown');
        $allPopups.removeClass('shown');
        $overlay.removeClass('shown');
        slate.popUpShown = false;
      }
    }

    if ($html.hasClass('notification-shown')) {
      $html.removeClass('notification-shown');
    }
  });

  // Close popups on escape key press
  $(document).on('keydown', function (e) {
    // If escape key pressed
    if (e.keyCode == 27) {
      if (slate.popUpShown) {
        if (!slate.redirectPopupShown) {
          $html.removeClass('popup-shown');
          $allPopups.removeClass('shown');
          $overlay.removeClass('shown');
          slate.popUpShown = false;
        }
      }

      if ($html.hasClass('notification-shown')) {
        $html.removeClass('notification-shown');
      }
    }
  });

  $body.on('click', '.accordion-toggle', function () {
    var $this = $(this),
      $accordion = $this.closest('.accordion'),
      accordionActive = true;

    if ($accordion.hasClass('only-mobile')) {
      checkMediaQuery();

      if (
        browserWidth == 'medium' ||
        browserWidth == 'large' ||
        browserWidth == 'xlarge' ||
        browserWidth == 'xxlarge'
      ) {
        accordionActive = false;
      }
    }

    if ($accordion.hasClass('only-small')) {
      checkMediaQuery();

      if (
        browserWidth == 'xlarge' ||
        browserWidth == 'xxlarge'
      ) {
        accordionActive = false;
      }
    }

    if (accordionActive) {
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $accordion.find('.accordion-content').slideUp(200);
      } else {
        $this.addClass('active');
        $accordion.find('.accordion-content').slideDown(200);
      }
    }
  });

  // Hide dropdowns on body click
  $body.on('click', function (e) {
    if (theme.enableMiniCart) {
      // Don't close mini cart if user has clicked inside it
      if (!$(e.target).closest($miniCart).length) {
        $html.removeClass('mini-cart-shown');
      }
    }

    // Don't close slide out search on clicks inside it or on toggle icon click
    if (
      !(
        $(e.target).closest($slideOutSearch).length ||
        $(e.target).closest($toggleSearch).length
      )
    ) {
      $slideOutSearch.removeClass('shown');
      $toggleSearch.removeClass('active');
    }

    checkMediaQuery();
    // Only run on mobile
    if (
      browserWidth == 'small' ||
      browserWidth == 'medium' ||
      browserWidth == 'large'
    ) {
      // Don't close mobile nav on clicks inside it
      if (!$(e.target).closest($mobileNav).length) {
        $html.removeClass('mobile-nav-shown');
      }
      // Only run on desktop
    } else {
      // Don't close menu on clicks inside it
      if (!$(e.target).closest($submenus).length) {
        $mainMenuItems.removeClass('active');
      }
    }
  });

  const initSticky = function (container) {
    if ($(container).length) {
      $(window).on('scroll', function () {
        if ($(window).scrollTop() > 0) {
          $(container).addClass('sticky');
        } else {
          $(container).removeClass('sticky');
        }
      });
    }
  };

  const ScrollExecute = function () {
    $('#more').addClass('loading');
    $('#more .text').text('Loading');
    scrollNode = $('.more').last();
    scrollURL = $('.more').last().attr('href');
    changeNode = $('.more').last();
    pageNumber = $('.more').last().attr('href');
    pagesEnd = parseInt($('.pagesEnd').text());
    pageNumber = pageNumber.match(/page=(.*\d)/gi);
    pageNumber = parseInt(pageNumber[0].replace('page=', ''));

    if (pagesEnd >= pageNumber) {
      if (scrollNode.length > 0) {
        $.ajax({
          type: 'GET',
          url: scrollURL,
          beforeSend: function () {
            $('#more button').prop('disabled', true);
            scrollNode.clone().empty().insertAfter(scrollNode);
          },
          success: function (data) {
            document
              .getElementById('product-list-foot')
              .insertAdjacentHTML('beforebegin', data);

            // Hide load after loading last page
            const resultsLength = document.querySelectorAll('.product').length;
            if (pagesEnd === pageNumber || resultsLength % 20 !== 0) {
              $('#more').hide();
            }

            // Remove loading feedback
            $('#more button').prop('disabled', false);

            pageNumber++;

            if (window.location.href.includes('&q')) {
              let newHref = window.location.href.replace(
                '&q=',
                `&page=${pageNumber.toString()}&view=api&q=`
              );
              changeNode.attr('href', newHref);
            } else {
              changeNode.attr(
                'href',
                `${window.location.href}?page=${pageNumber.toString()}&view=api`
              );
            }
            changeNode.insertBefore($('#product-list-foot'));

            $('#more .text').text('More');
            $('#more').removeClass('loading');

            // Check for items already in wishlist
            if (typeof iwishCheckColl == 'function') {
              iwishCheckColl();
            }

            const $swatchContainer = document.querySelectorAll('.swatches');
            const $atcBtns = document.querySelectorAll(`.for-page-${pageNumber - 1} .toggle-sizes`);
            const $sizes = document.querySelectorAll(`.for-page-${pageNumber - 1} .product-sizes`);

            addQuickBuyToProductCards($atcBtns, $sizes);
            addSwatchesToProductCards($swatchContainer);
          },
          dataType: 'html',
        });
      }
    } else {
      $('#more').hide();
    }
    return false;
  };

  /*================ AJAX Cart ================*/
  ajaxCart.init({
    showPopup: theme.addToCartPopup,
    miniCart: theme.enableMiniCart,
    formSelector: '.add-to-cart-form',
    cartContainer: '#cart-container',
    miniCartContainer: '#mini-cart-container',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '.cart-item-count',
    cartImgSize: '200x', // Shopify size: e.g. '300x200_crop_center'
    cartImgSrcset: ['200x', '400x'], // Array of Shopify sizes (width requsuggestionsired for srcset)
    miniCartImgSize: '80x',
    miniCartImgSrcset: ['80x', '160x'],
    popupImgSize: '200x',
    popupImgSrcset: ['200x', '400x'],
  });

  if (theme.enableMiniCart) {
    $body.on('click', 'a.toggle-mini-cart', function (e) {
      e.preventDefault();
      e.stopPropagation(); // Don't count this as a body click because it will close the cart
      $slideOutSearch.removeClass('shown');
      $toggleSearch.removeClass('active');
      if ($html.hasClass('mini-cart-shown')) {
        $html.removeClass('mini-cart-shown');
      } else {
        ajaxCart.loadMini();
        $html.removeClass('mobile-nav-shown');
      }
    });
  }

  // Autoplay iframe videos
  const videoData = $('[data-autoplay-settings]');

  const autoplayVimeo = () => {
    for (let i = 0; i < videoData.length; i++) {
      const autoplaySettings = $(videoData[i]).data('autoplay-settings');
      const top_of_object = $(videoData[i]).position().top - 200;
      const bottom_of_object =
        $(videoData[i]).position().top + $(videoData[i]).outerHeight();
      const top_of_window = $(window).scrollTop();
      const src = `${$(videoData[i])
        .find('iframe')
        .attr('src')}${autoplaySettings}`;
      /* If the object is completely visible in the window, fade it it */
      if (top_of_window > top_of_object) {
        if (
          !$(videoData[i]).find('iframe').attr('src').includes(autoplaySettings)
        ) {
          if (!$(videoData[i]).hasClass('slideshow__video')) {
            $(videoData[i]).find('iframe').attr('src', src);
          } else if ($(videoData[i]).parents('.owl-item').hasClass('active')) {
            $(videoData[i]).find('iframe').attr('src', src);
          }
        }
      }
    }
  };

  /*================ Customer account ================*/
  let enableNotification = false;
  if (enableNotification) {
    if ($('[data-customer-notification]').length) {
      let shown = localStorage.getItem('customer-notification--shown');
      if (!shown) {
        window.localStorage.setItem('customer-notification--shown', true);
        $('[data-customer-notification]').show();
      } else {
        $('[data-customer-notification]').hide();
      }
    }
  }

    /*================ Header ================*/
    const header = document.querySelector('.full-header');
    const accordian_triggers = document.querySelectorAll('.accordian-trigger');

    if(accordian_triggers) {
        accordian_triggers.forEach((accordian_trigger) => {
            accordian_trigger.addEventListener("click", (e) => {
                // Toggle element set on .accordian_trigger elements
                let elementToToggle = e.target.dataset.toggle;
                // Toggle this accordian trigger for + -
                e.target.classList.toggle('active');
                document.querySelector(elementToToggle).classList.toggle('active')
            })
        })
    }

  /*================ Index Page ================*/
  if ($body.hasClass('template-index')) {
    // Slideshows
    const $mainSlideshow = $('.owl-carousel.one-slide');
    $mainSlideshow.owlCarousel({
      nav: true, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      items: 1,
      itemsDesktop: false,
      itemsDesktopSmall: false,
      itemsTablet: false,
      itemsMobile: false,
      video: true,
      dots: false,
    });

    $('.owl-carousel:not(.one-slide)').owlCarousel({
      nav: false,
      loop: false,
      stagePadding: 0,
      dots: false,
      autoWidth: true,
      responsive: {
        0: {
          items: 1.3,
        },
        1000: {
          items: 4,
          autoWidth: false,
          mouseDrag: false,
        },
      },
    });

    if ($('.owl-carousel.one-slide').find('iframe')) {
      $('.owl-carousel.one-slide').on('changed.owl.carousel', function (event) {
        for (let i = 0; i < videoData.length; i++) {
          if ($(videoData[i]).parents('owl-item.active')) {
            const autoplaySettings = $(videoData[i]).data('autoplay-settings');
            const top_of_object = $(videoData[i]).position().top - 200;
            const bottom_of_object =
              $(videoData[i]).position().top + $(videoData[i]).outerHeight();
            const top_of_window = $(window).scrollTop();
            const src = `${$(videoData[i])
              .find('iframe')
              .attr('src')}${autoplaySettings}`;
            /* If the object is completely visible in the window, fade it it */
            if (
              !$(videoData[i])
                .find('iframe')
                .attr('src')
                .includes(autoplaySettings)
            ) {
              $(videoData[i]).find('iframe').attr('src', src);
            }
          }
        }
      });
    }
  }

  /*================ Collection Page ================*/
  if ($body.hasClass('template-collection')) {
    initSticky('.collection__head');



    if (document.querySelector('#more')) {
      $(document).ready(function () {
        var blockLoad = false;
        $(window).on('scroll', function () {
          let scrollPosition = parseInt(
            $(window).scrollTop() + $(window).height()
          );
          let loadMorePosition = $('#more').offset().top;

          if (scrollPosition - 100 > loadMorePosition) {
            if (!blockLoad) {
              blockLoad = true;
              ScrollExecute();
              setTimeout(() => {
                blockLoad = false;
              }, 3000);
            }
          }
        });

        $('#more button').on('click', function () {
          ScrollExecute();
        });
      });
    }
  }

  const addQuickBuyToProductCards = ($atcBtns, $sizes) => {
    $atcBtns.forEach(($btn) => {
      $btn.addEventListener('mouseenter', (e) => {
        const $form = e.target.parentNode;
        $form.classList.toggle('active');
      });
    });

    $sizes.forEach(($size) => {
      $size.addEventListener('mouseleave', (e) => {
        const $form = e.target.parentNode;
        $form.classList.toggle('active');
      });
    });
  };

  const addSwatchesToProductCards = ($swatchContainer) => {
    if ($swatchContainer.length) {
        $swatchContainer.forEach((s) => {
            var commonHandle = s.dataset.productHandle,
            currentColorTag = s.dataset.productColor,
            price = s.dataset.price
       
            if(s.querySelector('.swatch')) { 
                return
             }
          // Using the common product tag to find out all color variants as products in Shopify
          $.get('/collections/all/' + commonHandle + '?view=swatches').done(
            function (data) {
              var productArray = JSON.parse(data);
              productArray[0].product.swatches.forEach(function (product) {
                if (product.color && price && parseInt(price) == product.price) {
                  var swatchURL = ' href="' + product.url + '"',
                    swatchTitle = ' title="' + product.color_title + '"',
                    swatchStyle = '',
                    swatchImage = '',
                    showBorder = false,
                    swatchClass = ` has-border`;
       
                  if (product.color_hex) {
                    swatchStyle = ' style="background:' + product.color_hex + '"';
                  }
       
                  if (product.image) {
                    swatchImage = `<img src="${product.image}" alt="${product.color_title}" />`;
                  }
       
                  if (product.color_title.toLowerCase().includes('white')) {
                    showBorder = true;
                  }
       
                  // Compose the swatch element
                  if (currentColorTag === product.color) {
                    var $swatch = $(
                      `<div class="swatch active${
                        showBorder ? swatchClass : ''
                      }" ${swatchTitle} ${swatchStyle}>${swatchImage}</div>`
                    );
                  } else {
                    var $swatch = $(
                      `<a class="swatch${
                        showBorder ? swatchClass : ''
                      }" ${swatchURL} ${swatchTitle} ${swatchStyle}>${swatchImage}</a>`
                    );
                  }
       
                  $swatch.appendTo(s);
                }
              });
       
              // Don't group selectors if there's too many swatches
              var $selectorsOuter = $('.selectors-outer');
       
              if ($selectorsOuter.length) {
                if (productArray.length > 3) {
                  $selectorsOuter.removeClass('grouped');
                }
              }
            }
          );
        }) 
    }
  }

  /*================ Collection & Search Page ================*/
  if ($body.hasClass('template-collection') || $body.hasClass('template-search')) {
    // Product card atc
    const $swatchContainer = document.querySelectorAll('.swatches');
    const $atcBtns = document.querySelectorAll('.toggle-sizes');
    const $sizes = document.querySelectorAll('.product-sizes');

    addQuickBuyToProductCards($atcBtns, $sizes);
    addSwatchesToProductCards($swatchContainer)

    document.addEventListener('change', (e) => {
      if (!e.target.dataset.atcButtonId) return;

      ajaxCart.init({
        showPopup: theme.addToCartPopup,
        miniCart: theme.enableMiniCart,
        formSelector: '.add-to-cart-form',
        cartContainer: '#cart-container',
        miniCartContainer: '#mini-cart-container',
        addToCartSelector: '[data-add-to-cart]',
        cartCountSelector: '.cart-item-count',
        cartImgSize: '200x', // Shopify size: e.g. '300x200_crop_center'
        cartImgSrcset: ['200x', '400x'], // Array of Shopify sizes (width requsuggestionsired for srcset)
        miniCartImgSize: '80x',
        miniCartImgSrcset: ['80x', '160x'],
        popupImgSize: '200x',
        popupImgSrcset: ['200x', '400x'],
      });

      const atc = document.getElementById(e.target.dataset.atcButtonId);

      atc.click();
    })
  }

  /*================ Product Page ================*/
  if ($body.hasClass('template-product')) {
    const $productSlider = $('.product__slideshow');
    $productSlider.trigger('destroy.owl.carousel');
    $productSlider
      .html($productSlider.find('.owl-stage-outer').html())
      .removeClass('owl-loaded');

    $productSlider.owlCarousel({
      nav: true, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      items: 1,
      itemsDesktop: false,
      itemsDesktopSmall: [990, 1],
      itemsTablet: false,
      itemsMobile: false,
      video: false,
      dots: false,
      responsive: {
        0: {
          items: 1,
          mouseDrag: true,
        },
        990: {
          items: 1,
          nav: false,
          mouseDrag: false,
          pullDrag: false,
          touchDrag: false,
          autoheight: true,
          singleItem: true,
        },
      },
    });

    // Product sizes
    const size_button_active = $('.product__radioSelector button.active'),
      but_sold_out = size_button_active.data('sold-out');

    if (size_button_active.length === 0) {
      $('.add-to-cart-form .btn[name="add"]')
        .prop('disabled', true)
        .addClass('disabled');
      $('.add-to-cart-form .btn[name="add"] > span').text('Please select size');
      $('.add-to-cart-form .iwishAddWrap').addClass('disabled');
    }
    if (but_sold_out) {
      $('.add-to-cart-form .btn[name="add"]').addClass('hidden');
      $('.add-to-cart-form .iwishAddWrap').addClass('hidden');
    } else {
      $('.add-to-cart-form .btn[name="add"]').removeClass('hidden');
      $('.add-to-cart-form .iwishAddWrap').removeClass('hidden');
    }

    const size_button = $('.product__radioSelector button');
    size_button.on('click', function (e) {
      e.preventDefault();

      size_button.removeClass('active');
      const value = $(this).addClass('active').data('value');
      const sold_out = $(this).data('sold-out');

      $('select[data-product-sizes]').val(value).change();
      if (sold_out) {
        $('.add-to-cart-form .btn[name="add"]').addClass('hidden');
        $('.add-to-cart-form .iwishAddWrap').addClass('hidden');
      } else {
        console.log('stocked');
        $('.add-to-cart-form .btn[name="add"]').removeClass('hidden');
        $('.add-to-cart-form .iwishAddWrap').removeClass('hidden');
      }
      // Let Klaviyo Back in Stock knows about the change
      document.body.dispatchEvent(new Event('change'));
    });

    // Product swatches
    var $swatchContainer = $('.swatches');

    if ($swatchContainer.length) {
      var commonHandle = $swatchContainer.data('product-handle'),
        currentColorTag = $swatchContainer.data('product-color'),
        price = $swatchContainer.data('price');

      // Using the common product tag to find out all color variants as products in Shopify
      $.get('/collections/all/' + commonHandle + '?view=swatches').done(
        function (data) {
          var productArray = JSON.parse(data);
          productArray[0].product.swatches.forEach(function (product) {
            if (product.color && price && parseInt(price) == product.price) {
              var swatchURL = ' href="' + product.url + '"',
                swatchTitle = ' title="' + product.color_title + '"',
                swatchStyle = '',
                swatchImage = '',
                showBorder = false,
                swatchClass = ` has-border`;

              if (product.color_hex) {
                swatchStyle = ' style="background:' + product.color_hex + '"';
              }

              if (product.image) {
                swatchImage = `<img src="${product.image}" alt="${product.color_title}" />`;
              }

              if (product.color_title.toLowerCase().includes('white')) {
                showBorder = true;
              }

              // Compose the swatch element
              if (currentColorTag === product.color) {
                var $swatch = $(
                  `<div class="swatch active${
                    showBorder ? swatchClass : ''
                  }" ${swatchTitle} ${swatchStyle}>${swatchImage}</div>`
                );
              } else {
                var $swatch = $(
                  `<a class="swatch${
                    showBorder ? swatchClass : ''
                  }" ${swatchURL} ${swatchTitle} ${swatchStyle}>${swatchImage}</a>`
                );
              }

              $swatch.appendTo($swatchContainer);
            }
          });

          // Don't group selectors if there's too many swatches
          var $selectorsOuter = $('.selectors-outer');

          if ($selectorsOuter.length) {
            if (productArray.length > 3) {
              $selectorsOuter.removeClass('grouped');
            }
          }
        }
      );
    }

    let sizeGuide = $('.size-guide');
    let sizeGuide__button = $('.size-guide__header button');
    let sizeGuide__tools = $('.size-guide__tools');
    let _shoes = $('button[data-guide-collection="shoes"]');
    let _clothing = $('button[data-guide-collection="clothing"]');
    let _bodyM = $('button[data-guide-type="bm"]');
    let _sizes = $('button[data-guide-type="sizes"]');

    if (sizeGuide.length) {
      sizeGuide__button.on('click', function (event) {
        event.preventDefault();
        const activeClass = 'active';
        const _guideType = 'guideType';
        const _guideCollection = 'guideCollection';
        if (!$(this).hasClass('.active')) {
          $(this).parent().siblings().find('button').removeClass(activeClass);
          $(this).addClass(activeClass);

          if (!_bodyM.hasClass(activeClass)) {
            _shoes.fadeIn();
          }

          if ($(this).data(_guideType) == 'bm') {
            _shoes.fadeOut();
            _clothing.click();
          }

          if (!_bodyM.hasClass('active')) {
            sizeGuide__tools.removeClass('active');
            $('button[data-measurement="cm"]').click();
          }

          const sizeGuide__active = $('.size-guide button.active');
          const _type = sizeGuide__active.eq(0).data(_guideType);
          const _collection = sizeGuide__active.eq(1).data(_guideCollection);
          const sizeGuide__table = $('.size-guide__table');

          sizeGuide__table.removeClass(activeClass);
          $(
            '.size-guide__table[data-guide-type="' +
              _type +
              '"][data-guide-collection="' +
              _collection +
              '"]'
          ).addClass(activeClass);
        } else {
          return false;
        }
      });

      let _tools = $('.size-guide__tools button');
      let sizeGuide__table = $('.size-guide__table');

      sizeGuide__table.find('td:not(:first-child)').each(function () {
        const val = parseInt($(this).text());
        $(this).wrapInner('<span class="cm"></span>');
        $(this).append('<span class="inches">' + toInches(val) + '</span>');
      });

      _bodyM.on('click', function (event) {
        event.preventDefault();
        sizeGuide__tools.addClass('active');
      });

      _tools.on('click', function (event) {
        event.preventDefault();
        _tools.removeClass('active');
        $(this).addClass('active');
        sizeGuide__table.find('td > span').hide();
        sizeGuide__table
          .find('td > span' + '.' + $(this).data('measurement'))
          .show();
      });
    }

    // Product gallery Video

    let product_video = $('.product-video'),
      product_video2 = $('.product-video iframe'),
      owl_items = $('.owl-item'),
      other_images = $('.product__media-wrap .product-top-image');

    setTimeout(() => {
      let height = $('.owl-item.active .product-top-image img')
        ? $('.owl-item.active .product-top-image img').height()
        : $('.product-top-ph-image img').height();

      product_video.height(height);
      product_video2.height(height);

      other_images.height(height);

      product_video.each((index, item) => {
        if ($(item).attr('src') !== undefined) {
          let newSrc =
            $(item).attr('src') + '&autoplay=1&loop=1&autopause=0&muted=1';
          // infinite loop add playlist  `&playlist=M7lc1UVf-VE`
          $(item).attr('src', newSrc);
        }
      });
    }, 1000);

    $(window).on('resize', function (event) {
      setTimeout(() => {
        let height = $('.owl-item.active .product-top-image img')
          ? $('.owl-item.active .product-top-image img').height()
          : $('.product-top-ph-image img').height();
        console.log(height);

        product_video.height(height);
        product_video2.height(height);
        owl_items.height(height);
        other_images.height(height);

        product_video.each((index, item) => {
          if ($(item).attr('src') !== undefined) {
            let newSrc = $(item).attr('src') + '&autoplay=1&loop=1&muted=1';
            $(item).attr('src', newSrc);
          }
        });
      }, 1000);
    });
  }
  /*================ Search Page ================*/
  if ($body.hasClass('page-size-guide')) {
    let sizeGuide = $('.size-guide');
    let sizeGuide__button = $('.size-guide__header button');
    let sizeGuide__tools = $('.size-guide__tools');

    if (sizeGuide.length) {
      let _tools = $('.size-guide__tools button');
      let sizeGuide__table = $('.size-guide__table');

      sizeGuide__table.find('td:not(:first-child)').each(function () {
        const val = parseInt($(this).text());
        $(this).wrapInner('<span class="cm"></span>');
        $(this).append('<span class="inches">' + toInches(val) + '</span>');
      });

      _tools.on('click', function () {
        _tools.removeClass('active');
        $(this).addClass('active');
        sizeGuide__table.find('td > span').hide();
        sizeGuide__table
          .find('td > span' + '.' + $(this).data('measurement'))
          .show();
      });
    }
  }
  /*================ Search Page ================*/
  if ($body.hasClass('template-search')) {
    initSticky('#search__filter, .search__main-content');

    // Filter
    let newString = '';
    if ($('.search-filter__button.selected').length > 0) {
      $('.search-filter__button.selected').each(function () {
        newString += $(this).val();
      });
    }
    // bind change event to select
    $('.search-filter__button').on('click', function () {
      let val = $(this).val();

      if ($(this).hasClass('selected')) {
        const originalUrl = window.location.href.replace(val, '');
        window.location.href = originalUrl;
      } else {
        const key = `tag%3A`;
        const loc = window.location.href;
        const originalUrl = window.location.href.split('+tag');
        const replaceStr = $(this)
          .parent()
          .siblings()
          .find('.search-filter__button.selected')
          .val();
        newString = newString.replace(replaceStr, '');
        if (newString) {
          window.location.href = `${originalUrl[0]}${newString}${val}`; // redirect
        } else {
          window.location.href = `${originalUrl[0]}${val}`;
        }
        return false;
      }
    });

    $('.search-filter__toggle').on('click', function () {
      window.localStorage.setItem(
        'js-filters--visible',
        !$('.search-filter__category').is(':visible')
      );
      $(this).toggleClass('active');
      $('#search__filter').toggleClass('active');
      $('.search-filter__category').slideToggle(200);
    });

    let isVisible = localStorage.getItem('js-filters--visible');
    if (isVisible == 'true') {
      $('.search-filter__toggle').toggleClass('active');
      $('#search__filter').toggleClass('active');
      $('.search-filter__category').toggle();
    }

    // infinite scroll
    $(document).ready(function () {
      $(window).on('scroll', function () {
        if (
          $(window).scrollTop() + $(window).height() ==
          $(document).height()
        ) {
          ScrollExecute();
        }
      });

      $('#more button').on('click', function () {
        ScrollExecute();
      });
    });
  }
  /*================ Search Page ================*/
  if ($body.hasClass('template-stores')) {
    $('.store__trigger-map button').on('click', function () {
      var map = $(this)
        .parents('.store__content')
        .siblings('.store__images')
        .find('.store__map');
      if (!map.is(':visible')) {
        $('html, body').animate(
          {
            scrollTop: $(this)
              .parents('.store__content')
              .siblings('.store__images')
              .offset().top,
          },
          200
        );
      }
      $(this).text($(this).text() == 'Close' ? $(this).data('text') : 'Close');
      map.fadeToggle(200);
    });
  }
});
